module.exports = __webpack_public_path__ + "img/DSC00061.8d7cd02b.JPG";